import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import "./Login.scss";
import { useCookies } from "react-cookie";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../../Services/Redux/Reducer/Reducer";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import { toast } from "react-toastify";
import {
  TOASTER_CONFIGS,
  API_RESPONSE,
  TOKENS,
  LANGUAGES,
  LOGIN_FIELDS,
  LAYOUTS,
  ADMIN_ROLES,
  ROUTES,
  AUTHENTICATION_LABELS,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  STORAGE_KEYS,
  VALIDATION_CONSTANT,
  COMMON_CONSTANTS,
} from "../../../Utilities/Constants/Constants";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import { SetSessionStorageData, clearSessionKey, clearSessionStorage, nullUndefinedEmptyCheck } from "../../../Services/Helpers/Helper";
import {
  ERROR_MESSAGES,
  REGEX,
} from "../../../Utilities/Constants/Validations";
import { useNavigate } from "react-router-dom";
import LanguageIcon from "@mui/icons-material/Language";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-input-2";
import loginBanner from "../../../../Assets/Registration/signup_banner.svg";
import phygitalLogo from "../../../../Assets/global/phygital_logo.svg"

const Login = () => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [signupMode, setSignUpMode] = useState(STORAGE_KEYS.EMAIL);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [validPhoneNumber, setValidPhoneNumber] = useState(API_RESPONSE.TRUE);

  /* Navigatoin hook**/
  const navigate = useNavigate();
  /* Toggle language**/
  const changeLanguage = (languageCode: string) => {
    dispatch(
      setLanguage(
        language === LANGUAGES.ENGLISH ? LANGUAGES.ARABIC : LANGUAGES.ENGLISH
      )
    );
    i18n.changeLanguage(languageCode);
  };
  /* set and get language from redux**/
  const dispatch = useDispatch();
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  /* signup yup validation schema */
  const SignUpValidationSchema = yup.object({
    email: yup
      .string()
      .required(ERROR_MESSAGES.EMAIL_REQUIRED)
      // .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .email(ERROR_MESSAGES.INVALID_EMAIL)
      .trim(),
  });

  /* phone validation schema */
  const PhoneValidationSchema = yup.object({
    phone_number: yup.string(),
  });

  /* Updating login type */
  const onChangeMode = () => {
    signupMode === STORAGE_KEYS.EMAIL
      ? setSignUpMode(STORAGE_KEYS.MOBILE)
      : setSignUpMode(STORAGE_KEYS.EMAIL);
  };

  /* Validate phone number */
  const validatePhoneNumber = (e: any) => {
    isValidPhoneNumber(e);
    isValidPhoneNumber(e) === API_RESPONSE.TRUE
      ? setValidPhoneNumber(API_RESPONSE.TRUE)
      : setValidPhoneNumber(API_RESPONSE.FALSE);
    return isValidPhoneNumber(e);
  };

  /* Submit API call */
  const onSubmit = (loginType: any, payload: any) => {
    clearSessionStorage();
    axiosInstance
      .post(
        API_END_POINTS.LOGIN_API + `?${STORAGE_KEYS.LOGIN_TYPE}=` + loginType,
        payload
      )
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          toast.success(response.data.message, TOASTER_CONFIGS);
          navigate(ROUTES.OTP_VERIFICATION);
        }
      })
      .catch(() => { });
  };

  /* Signup API call */
  const onCreateAccount = (value: any) => {
    clearSessionStorage();
    SetSessionStorageData(STORAGE_KEYS.MODE, AUTHENTICATION_LABELS.LOGIN);
    clearSessionKey(STORAGE_KEYS.OTP_EXPIRED);
    if (signupMode === STORAGE_KEYS.EMAIL) {
      let payload = {
        email: value.email.trim(),
        roles: `${NUMBER_CONSTANTS.FOUR}`,
      };
      onSubmit(NUMBER_CONSTANTS.ONE, payload);
      SetSessionStorageData(STORAGE_KEYS.LOGIN_TYPE, NUMBER_CONSTANTS.ONE);
      SetSessionStorageData(STORAGE_KEYS.EMAIL, value.email);
    } else {
      let phone_number =
        phoneNumber.split(COMMON_CONSTANTS.PLUS).length > NUMBER_CONSTANTS.ONE
          ? phoneNumber
          : COMMON_CONSTANTS.PLUS + phoneNumber;

      if (validatePhoneNumber(phone_number)) {
        let payload = {
          phone_number: phone_number,
          roles: `${NUMBER_CONSTANTS.FOUR}`,
        };
        onSubmit(NUMBER_CONSTANTS.ZERO, payload);
        SetSessionStorageData(STORAGE_KEYS.LOGIN_TYPE, NUMBER_CONSTANTS.ZERO);
        SetSessionStorageData(STORAGE_KEYS.PHONE_NUMBER, phoneNumber);
      }
    }
  };

  /* Handling enter keypress */
  const handleKeyPress = (event: any) => {
    if (
      event.key === VALIDATION_CONSTANT.KEY_TYPE &&
      nullUndefinedEmptyCheck(event.target.value.trim())
    ) {

    }
  };

  return (
    <div
      className="row login-wrapper"
      dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}
    >
      <div className="col-md-6 logo-contents">
        {<img className="login-banner" src={loginBanner} />}
      </div>
      <div
        className={
          language === LANGUAGES.ENGLISH
            ? "col-md-6 column-wrap"
            : "col-md-6 column-wrap-rtl"
        }
      >
        <div className="row language_switch_header">
          <div className="language_switch_contianer">
            <LanguageIcon className="language_icon" />
            <button
              className="language_button"
              onClick={() => {
                changeLanguage(
                  language === LANGUAGES.ENGLISH
                    ? LANGUAGES.ARABIC_ABBRIVATION
                    : LANGUAGES.ENGLISH_ABBRIVATION
                );
              }}
            >
              {language === LANGUAGES.ENGLISH
                ? LANGUAGES.ARABIC
                : LANGUAGES.ENGLISH}
            </button>
          </div>
        </div>

        <div className="form-wrapup">
          <div className="form-contents">
            {/*  <img src={phygitalLogo} alt="Learn & Play"/> */}
            <h2 className="form-heading">{t("WELCOME BACK")}</h2>
            <Formik
              initialValues={
                signupMode === STORAGE_KEYS.EMAIL
                  ? { email: "" }
                  : { phone_number: "" }
              }
              validationSchema={
                signupMode === STORAGE_KEYS.EMAIL
                  ? SignUpValidationSchema
                  : PhoneValidationSchema
              }
              onSubmit={(values, actions) => {
                onCreateAccount(values);
              }}
            >
              {(formik) => {
                return (
                  <div>
                    {signupMode === STORAGE_KEYS.EMAIL && (
                      <div className="form-items">
                        <label className="form-label">
                          {t("Email Address")}
                        </label>
                        <Field
                          name={STORAGE_KEYS.EMAIL}
                          className="email-input"
                          placeholder={t("Enter Email Address")}
                          onKeyPress={(event: any) => {
                            if (event.key === VALIDATION_CONSTANT.KEY_TYPE) {
                              formik.handleSubmit();
                            }
                          }}
                        />
                        <div className="errorMessage">
                          {formik.touched.email && formik.errors.email && (
                            <p>{t(`${formik.errors.email}`)}</p>
                          )}
                        </div>
                      </div>
                    )}

                    {signupMode === STORAGE_KEYS.MOBILE && (
                      <div className="form-items">
                        <label className="form-label">
                          {t("Phone Number")}
                        </label>
                        <PhoneInput
                          inputProps={
                            language === LANGUAGES.ENGLISH
                              ? {
                                className:
                                  "input email-input phone_num_input",
                                name: "phone_number",
                              }
                              : {
                                className: "input phone_num_input-rtl",
                                name: "phone_number",
                              }
                          }
                          countryCodeEditable={API_RESPONSE.FALSE}
                          country={"ae"}
                          enableSearch={API_RESPONSE.TRUE}
                          value={phoneNumber}
                          onChange={(e: any) => {
                            setPhoneNumber(e);
                            setTimeout(() => {
                              validatePhoneNumber("+" + e);
                            }, 0);
                          }}
                        />
                        <div className="errorMessage">
                          {validPhoneNumber === API_RESPONSE.FALSE && (
                            <p>{t(ERROR_MESSAGES.PHONE_INPUT)}</p>
                          )}
                        </div>
                      </div>
                    )}

                    <button
                      className={
                        formik.isValid
                          ? "btn create-btn"
                          : "btn create-btn-disabled"
                      }
                      type="submit"
                      onClick={() => {
                        formik.handleSubmit();
                      }}
                    >
                      {t("Login")}
                    </button>
                  </div>
                );
              }}
            </Formik>

            {/* <p id="conditions-text">
              {t('By continuing, you agree to Learn&Play’s')}{" "}
              <span id="bold-text">{t('Terms of Service')}</span> &{" "}
              <span id="bold-text">{t('Privacy Policy')}</span>
            </p> */}

            <p id="conditions-text">
              {t("Don't have an account?")}{" "}
              <span
                className="login-text"
                onClick={() => {
                  navigate(ROUTES.SIGN_UP);
                }}
              >
                {t("Sign Up")}
              </span>
            </p>

            <p id="conditions-text">- {t("OR")} -</p>

            <div className="alternative-btn-wrap">
              <button className="btn alternative-btn" onClick={onChangeMode}>
                {signupMode === "email"
                  ? t("Login with phone number")
                  : t("Login with email")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
